import { login, qywxLogin, logout, getInfo } from '@/api/user'
import { wxfwhLogin, wxfwhGetLoginInfo } from '@/api/wx-fwh'
import { loginOfClientTerm, getLoginInfoOfClientTerm } from '@/api/settings/client'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { setTreeData } from '@/utils/index'

const state = {
  token: getToken(),
  name: '',
  avatar: '',
  userInfo: {},
  menus: [],
  permissions: []
}

const mutations = {
  set_token: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  set_menus: (state, menus) => {
    state.menus = menus
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
  }
}

const actions = {
  // user login
  login({ commit }, loginInfo) {
    const { username, password } = loginInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password }).then(resp => {
        const { success, msg, token } = resp
        if (success) {
          commit('set_token', token)
          setToken(token)
          resolve()
        } else {
          reject(msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  wxfwhLogin({ commit }, code) {
    return new Promise((resolve, reject) => {
      wxfwhLogin({
        code: code
      }).then(resp => {
        const { success, token } = resp
        if (success) {
          commit('set_token', token)
          setToken(token)
        }
        resolve(resp)
      }).catch(error => {
        reject(error)
      })
    })
  },

  qywxLogin({ commit }, loginInfo) {
    const { code, agent_id } = loginInfo
    return new Promise((resolve, reject) => {
      qywxLogin({ code: code.trim(), agent_id: agent_id }).then(resp => {
        const { success, msg, token } = resp
        if (success) {
          commit('set_token', token)
          setToken(token)
          resolve()
        } else {
          reject(msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  clientTermLogin({ commit }, loginInfo) {
    const { mobile, password } = loginInfo
    return new Promise((resolve, reject) => {
      loginOfClientTerm({ mobile: mobile.trim(), password: password }).then(resp => {
        const { success, msg, obj, token } = resp
        if (success) {
          commit('set_token', token)
          commit('SET_USER_INFO', obj)
          setToken(token)
          resolve()
        } else {
          reject(msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo().then(resp => {
        const { success, obj } = resp
        if (success) {
          const { Us, Mb, Pm } = obj
          if (Pm && Pm.length > 0) {
            const username = Us.username || Mb.name
            commit('SET_PERMISSIONS', Pm)
            commit('SET_NAME', username)
            commit('SET_USER_INFO', Us.id > 0 ? Us : Mb)
            commit('SET_AVATAR', 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif')
            resolve({ username: username, menus: [] })
          } else {
            reject('Verification failed, please Login again.')
          }
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  wxfwhGetInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      wxfwhGetLoginInfo().then(resp => {
        const { success, obj } = resp
        if (success) {
          const { Us, Mb, Pm } = obj
          if (Pm && Pm.length > 0) {
            const username = Us.username || Mb.name
            commit('SET_PERMISSIONS', Pm)
            commit('SET_NAME', username)
            commit('SET_USER_INFO', Us.id > 0 ? Us : Mb)
            commit('SET_AVATAR', 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif')
            resolve({ username: username, menus: [] })
          } else {
            reject('Verification failed, please Login again.')
          }
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  getInfoOfClientTerm({ commit }) {
    return new Promise((resolve, reject) => {
      getLoginInfoOfClientTerm().then(resp => {
        const { success, msg, obj } = resp
        if (success) {
          commit('SET_USER_INFO', obj)
          resolve()
        } else {
          reject(msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout({ token: state.token }).then(() => {
        commit('set_token', '')
        commit('set_menus', [])
        commit('SET_PERMISSIONS', [])
        commit('SET_NAME', '')
        commit('SET_AVATAR', '')
        removeToken()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('set_token', '')
      commit('set_menus', [])
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js